<div class="card card-primary card-outline style">
   
    <!------------Add edit button----------------->
   <a class="btn btn-info btn-sm edit" (click)='getValue();EditItem()'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
  <!-------------------------------------------->
    
  
        <div *ngFor="let c of output">
  
          <table class="table style">
          
          <tbody>
          
            <tr>
            <td style="width: 40%;"><b>Team Name :</b></td>
            <td>{{c.team_name}}</td>
            </tr>

            <tr>
            <td style="width: 40%;"><b>Brand Name :</b></td>
            <td>{{c.brand_name}}</td>
            </tr>

            <tr>
            <td style="width: 40%;"><b>Manager Name :</b></td>
            <td>{{c.brand_manager_name}}</td>
            </tr>
        

            <tr>
            <td><b>Month And Year :</b></td>
            <td>{{c.month_year}}</td>
            </tr>
  
            <!-- <tr>
              <td><b>Date :</b></td>
              <td>{{DateFormat1(c.date)}}</td>
              </tr> -->

              <tr>
                <td><b>Team Mates :</b></td>
                <td>
                  <div class="space" *ngFor="let d of c.team_mates;index as i">
                      <span>{{d.employee_name}}</span>
                      </div>
                </td>
                </tr>
  
            <tr>
            <td><b>Working Days :</b></td>
            <td>
              <div class="space" *ngFor="let d of c.working_days;index as i">
                  <span>{{DateFormat(d)}}</span>
                  </div>
            </td>
            </tr>
        
          </tbody>
      </table>      
  
  
